import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faImageLandscape } from '@fortawesome/pro-light-svg-icons'

import { Button } from '@domain-group/suit-theme'

import { generateUrls } from '@hooks/useCampaign'
import { useCampaignComparableImage } from '@hooks/useCampaignComparable'
import useImage from '@hooks/useImage'

import ModalImageUpload from '@components/ModalImageUpload'

import { CampaignComparableModel } from '@domain-group/realhub-backend-api-types'
import { confirmDelete } from '@functions/entity'

interface ComparableImageProps {
  campaignComparable: CampaignComparableModel,
}

const ComparableImage = (props: ComparableImageProps) => {
  const { campaignComparable } = props
  const { source_campaign_id } = campaignComparable

  const campaignComparableImageOptions = {
    image_type: 'photo',
    imageable_id: campaignComparable.id,
    imageable_type: 'CampaignComparable',
    requestOptions: {
      include_campaign_comparable_default_image: true,
      include_image_sizes: true,
    },
  }

  const { campaignMediaUrl } = generateUrls({ id: source_campaign_id })

  const { image, imageUrl } = useCampaignComparableImage(campaignComparable)

  const {
    callbacks: { deleteImage },
    deleting,
  } = useImage(image)

  const confirmDeleteParams = {
    callbacks: {
      deleteFn: deleteImage,
    },
    strings: {
      entityName: 'Image',
    },
  }

  return (
    <>
      <ModalImageUpload
        disableUpload={!!source_campaign_id}
        imageOptions={campaignComparableImageOptions}
        imageUrl={imageUrl}
        label="Comparable Image"
      />

      {/*
       // @ts-expect-error TS2339 */}
      {!!image.id && (
        <ModalImageUpload.ReplaceImage loading={deleting} onClick={() => confirmDelete(confirmDeleteParams)} />
      )}

      {source_campaign_id && (
        <Button
          // @ts-expect-error TS2322
          as="a"
          buttonStyle="secondaryUtility"
          href={campaignMediaUrl}
          icon={<FontAwesomeIcon icon={faImageLandscape} />}
          marginTop="medium"
          size="medium"
          width="auto"
        >
          View Campaign Media
        </Button>
      )}
    </>
  )
}

export default ComparableImage
